import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

import { ICity } from './ICity.model'

export enum STORE_ACTIONS {
  CITY_STORE_CITIES = 'city/storeCities'
}

export enum STORE_GETTERS {
  CITY_GET_CITIES = 'city/cities',
  CITY_GET_CITIES_BY_ID = 'city/citiesById',
  CITY_GET_CITIES_NAMES = 'city/citiesNames'
}

@Module({ namespaced: true })
export default class CityStore extends VuexModule {
  private _cities: Array<ICity> = []

  @Mutation
  private storeCitiesMutation(cities: Array<ICity> = []): void {
    this._cities = cities || []
  }

  @Action
  public storeCities(cities: Array<ICity>): void {
    this.context.commit('storeCitiesMutation', cities)
  }

  private get cities(): Array<ICity> {
    return this._cities || []
  }

  private get citiesById(): { [key: string]: ICity } {
    return this._cities.reduce((acc: { [key: string]: ICity }, city: ICity) => {
      return {
        ...acc,
        [city.id]: city
      }
    }, {})
  }

  private get citiesNames(): Array<string> {
    return this._cities.reduce((acc: Array<string>, city: ICity) => {
      return [
        ...acc,
        city.nom
      ]
    }, [])
  }
}
